export const STATUS = {
    PAUSED: "paused",
    ACTIVE: "active",
    ERROR: "error"
  }